import { initClockbar } from '../shared/clockbar.js';

export function initShabbosClockbar() {
    if (typeof $ === 'undefined') {
        console.error('initShabbosClockbar: jQuery is not loaded');
        return;
    }

    const shabbosRootSelector = '#index_paging .shabbos-mode-page';

    function sync() {
        if (window.shabbosClockbarInstance) {
            window.shabbosClockbarInstance.destroy();
            window.shabbosClockbarInstance = null;
        }

        const root = document.querySelector(shabbosRootSelector);
        if (!root) {
            return;
        }

        const container = root.querySelector('.shabbos-clockbar-container .clockbar');
        const canvas = root.querySelector('#shabbosAnalogClock');
        const timeEl = root.querySelector('#shabbosCurrentTime');
        const dateEl = root.querySelector('#shabbosCurrentDate');
        const hebrewDateEl = root.querySelector('#shabbosHebrewDate');

        if (!container || !canvas || !timeEl || !dateEl || !hebrewDateEl) {
            console.error('initShabbosClockbar: clockbar elements missing from Shabbos page markup');
            return;
        }

        window.shabbosClockbarInstance = initClockbar({
            canvas,
            timeEl,
            dateEl,
            hebrewDateEl,
            timeZone: container.dataset.timeZone || undefined
        });
    }

    $(document).off('ajaxComplete.shabbosClockbar').on('ajaxComplete.shabbosClockbar', sync);
    $(sync);
}
